<form [ngClass]="{'needs-validation': !frmConfigImpressao.submitted, 'was-validated': frmConfigImpressao.submitted}"
      novalidate #frmConfigImpressao="ngForm" (ngSubmit)="onSubmitConfigImpressao()">

  <h4>Configurações de Impressão</h4>
  <small class="text-muted">Configure como seus pedidos serão impressos</small>

  <div class="config-layout">
    <!-- Coluna Esquerda -->
    <div class="config-column">
      <!-- Formato de Impressão -->
      <div class="config-section">
        <div class="section-title">
          <i class="fe-file-text"></i>
          Formato de Impressão do Pedido
        </div>

        <div class="radio-group">
          <div class="radio-option">
            <input id="completo" name="layoutPedido" type="radio"
                   [(ngModel)]="empresa.configImpressao.layoutPedido"
                   value="PedidoCompleto" (change)="alterouLeiaute()"/>
            <label for="completo">
              Completo
              <small>Imprime todos os detalhes do pedido</small>
            </label>
          </div>

          <div class="radio-option">
            <input id="resumido" name="layoutPedido" type="radio"
                   [(ngModel)]="empresa.configImpressao.layoutPedido"
                   value="PedidoResumido" (change)="alterouLeiaute()"/>
            <label for="resumido">
              Resumido
              <small>Imprime versão condensada do pedido</small>
            </label>
          </div>

          <div class="radio-option">
            <input id="ambos" name="layoutPedido" type="radio"
                   [(ngModel)]="empresa.configImpressao.layoutPedido"
                   value="Ambos" (change)="alterouLeiaute()"/>
            <label for="ambos">
              Ambos
              <small>Imprime as duas versões</small>
            </label>
          </div>
        </div>
      </div>

      <!-- Impressão Automática -->
      <div class="config-section">
        <div class="section-title">
          <i class="fe-clock"></i>
          Impressão automática ocorre quando?
        </div>

        <div class="radio-group">
          <div class="radio-option">
            <input id="mudancaStatus" name="momentoImprimirAuto" type="radio"
                   [(ngModel)]="empresa.configImpressao.momentoImprimirAuto"
                   value="status-pedido" (change)="marqueRecarregar()"/>
            <label for="mudancaStatus">
              Mudança de status do pedido
              <small>Imprimir quando o status for alterado</small>
            </label>
          </div>

          <div class="radio-option">
            <input id="novoPedido" name="momentoImprimirAuto" type="radio"
                   [(ngModel)]="empresa.configImpressao.momentoImprimirAuto"
                   value="novo-pedido" (change)="marqueRecarregar()"/>
            <label for="novoPedido">
              Quando um novo pedido for feito
              <small>Imprimir imediatamente após receber o pedido</small>
            </label>
          </div>
        </div>
      </div>

      <!-- Permitir impressão de pedidos não pagos -->
      <div class="config-section">
        <div class="section-title">
          <i class="fe-dollar-sign"></i>
          Permitir a impressão de pedidos online não pagos?
        </div>

        <div class="radio-group">
          <div class="radio-option">
            <input id="sim" name="imprimirOnlineNaoPago" type="radio"
                   [(ngModel)]="empresa.configImpressao.imprimirOnlineNaoPago"
                   [value]="true" (change)="marqueRecarregar()"/>
            <label for="sim">Sim</label>
          </div>

          <div class="radio-option">
            <input id="nao" name="imprimirOnlineNaoPago" type="radio"
                   [(ngModel)]="empresa.configImpressao.imprimirOnlineNaoPago"
                   [value]="false" (change)="marqueRecarregar()"/>
            <label for="nao">Não</label>
          </div>
        </div>
      </div>

      <div class="input-group mt-0">
        <input  name="agruparAdicionais" id='agruparAdicionais'    class="k-checkbox  " type="checkbox" kendoCheckBox
                [(ngModel)]="empresa.configImpressao.agruparAdicionais"   />
        <label  class="k-checkbox-label" for="agruparAdicionais">
          Agrupar impressão dos adicionais pelo nome</label>

      </div>



      <div class="input-group mt-2">
        <input  name="ocultarCobranca" id='ocultarCobranca'    class="k-checkbox  " type="checkbox" kendoCheckBox
                [(ngModel)]="empresa.configImpressao.ocultarCobranca"   />
        <label  class="k-checkbox-label" for="ocultarCobranca">
          Ocultar dados de cobrança em pedidos nao pagos <br> ( mensagem cobrar do cliente e valor restante a pagar)</label>

      </div>



      <!-- Impressão nativa -->
      <div class="config-section" *ngIf="!isMobile">
        <div class="section-title">
          <i class="fe-printer"></i>
          Impressão nativa
        </div>

        <app-qztray-detect (onConectou)="conectouQzTray()" [titulo]="'Impressão nativa'"></app-qztray-detect>

        <ng-container *ngIf="!conectando && qzInstalado">
          <div class="checkbox-group">
            <label class="checkbox">
              <input type="checkbox" [(ngModel)]="empresa.configImpressao.imprimirTXT"
                     name="imprimirTXT" (change)="alterouTipoDeImpressao()">
              Realizar impressão em modo nativo
              <small>Impressão rápida e direta</small>
            </label>

            <label class="checkbox" *ngIf="empresa.configImpressao.imprimirTXT">
              <input type="checkbox" [(ngModel)]="empresa.configImpressao.modoHTML"
                     name="modoHTML">
              Utilizar o modo gráfico
              <small>*necessário driver nativo da impressora</small>
            </label>

            <label class="checkbox" *ngIf="empresa.configImpressao.imprimirTXT && empresa.configImpressao.modoHTML">
              <input type="checkbox" [(ngModel)]="empresa.configImpressao.cortarAutomatico"
                     name="modoHTML" name="cortarAutomatico">
              Enviar comando de corte ao fim da impressão
              <small>*use apenas se a impressora não cortar automático </small>
            </label>

            <label class="checkbox" *ngIf="empresa.configImpressao.imprimirTXT">
              <input type="checkbox" [(ngModel)]="empresa.configImpressao.emitirBeep"
                     name="emitirBeep">
              Emitir um beep após impressão
              <small>Alerta sonoro em impressoras compatíveis</small>
            </label>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Coluna Direita -->
    <div class="config-column">
      <!-- Nova Seção: Servidores de Impressão -->
      <!--   <div class="config-section">
         <div class="section-header">
           <div class="section-title">
             <i class="fe-server"></i>
             Servidores de Impressão
           </div>
           <button type="button" class="btn-add" (click)="abrirConfigServidorImpressao()">
             + Configurar Servidor
           </button>
         </div>
         <small class="text-muted">Configure servidores de impressão para impressão remota</small>

         <div class="servidores-info">
           <div class="info-item" *ngIf="!temServidorImpressao">
             <i class="fe-info"></i>
             <span>Nenhum servidor de impressão configurado. Configure um servidor para usar impressão remota.</span>
           </div>
           <div class="info-item" *ngIf="temServidorImpressao">
             <i class="fe-check-circle text-success"></i>
             <span>Sistema de impressão remota ativo. Os pedidos serão processados via jobs de impressão.</span>
           </div>
         </div>


        <div class="impressoras-list" *ngIf="servidoresImpressao.length > 0">
          <div class="impressora-item" *ngFor="let servidor of servidoresImpressao">
            <div class="item-content">
              <i class="fe-server"></i>
              <div class="item-info">
                <strong>{{servidor.nome}}</strong>
                <span>{{servidor.enderecoIP}}:{{servidor.porta || 8181}}</span>
                <div class="item-configs">
                  <span class="config-tag" [class]="obtenhaStatusClass(servidor)">
                    {{obtenhaStatusServidor(servidor)}}
                  </span>
                  <span class="config-tag" *ngIf="servidor.ativo">Ativo</span>
                  <span class="config-tag" *ngIf="!servidor.ativo">Inativo</span>
                  <span class="config-tag">{{servidor.impressoras?.length || 0}} impressoras</span>
                </div>
              </div>
            </div>
            <div class="item-actions">
              <button type="button" class="btn-icon" (click)="editarServidor(servidor)">
                <i class="fe-settings"></i>
              </button>
              <button type="button" class="btn-icon text-danger" (click)="removerServidor(servidor)">
                <i class="fe-trash-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>  -->

      <div class="config-section">
        <div class="section-header">
          <div class="section-title">
            <i class="fe-printer"></i>
            Impressoras Cadastradas
          </div>
          <button type="button" class="btn-add" (click)="adicionarNovaImpressa()"
                  *ngIf="empresa.configImpressao.multiplasImpressoras">
            + Adicionar impressora
          </button>
        </div>
        <small class="text-muted">Gerencie suas impressoras cadastradas no sistema</small>

        <div class="impressoras-list">
          <div class="impressora-item" *ngFor="let impressora of empresa.configImpressao.impressoras; let i = index"
               [class.removed]="impressora.removida">
            <div class="item-content">
              <i class="fe-printer"></i>
              <div class="item-info">
                <strong>{{impressora.setor || 'Sem setor'}}</strong>
                <span>{{impressora.nome || 'Selecione uma impressora'}}</span>

                <div class="item-configs">
                    <span *ngIf="impressora.servidorImpressao" class="badge badge-danger cpointer"
                          (click)="editarServidorDaImpressora(impressora)">
                           <i class="fe-server" style="color: #fff;"></i>   {{impressora.servidorImpressao.nome}}
                     </span>
                  <span class="config-tag" *ngIf="impressora.imprimirAutomatico">Auto</span>
                  <span class="config-tag" *ngIf="impressora.imprimirNFCe">NFCe</span>
                  <span class="config-tag" *ngIf="impressora.naoImprimirMesa">Não Mesa</span>
                  <span class="config-tag" *ngIf="impressora.naoImprimirDelivery">Não Delivery</span>
                  <span class="config-tag">{{getLabelLayout(impressora.layout)}}</span>
                  <span class="config-tag">{{getLabelTamanhoPapel(impressora.tamanhoPapel)}}</span>
                </div>
              </div>
            </div>
            <div class="item-actions">
              <button type="button" class="btn-icon" (click)="abrirConfigImpressora(impressora, i)">
                <i class="fe-settings"></i>
              </button>
              <button type="button" class="btn-icon text-danger" (click)="excluirImpressora(impressora)">
                <i class="fe-trash-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="alert alert-success" *ngIf="mensagemSucesso">
    <i class="fe-check-circle"></i> {{mensagemSucesso}}
  </div>

  <div class="alert alert-danger" *ngIf="erro">
    <i class="fe-alert-circle"></i> {{erro}}
  </div>

  <div class="alert alert-warning" *ngIf="impressorasAlteradas">
    <i class="fe-alert-triangle"></i>
    Existem alterações nas impressoras que ainda não foram salvas. Clique em "Salvar Configurações" para aplicar as mudanças.
  </div>

  <button type="submit" class="btn-save" [disabled]="salvando">
    <i class="fe-save"></i>
    Salvar Configurações
  </button>
</form>

<!-- Modal de Configuração -->
<kendo-dialog *ngIf="impressoraSelecionada"
              [title]="'Configurar Impressora'"
              (close)="fecharConfigImpressora()"
              [minWidth]="400"
              [width]="1120"
              class="printer-config-dialog">
  <form class="k-form" [ngClass]="{'needs-validation': !frmImpressora.submitted, 'was-validated': frmImpressora.submitted}"
        novalidate #frmImpressora="ngForm" (ngSubmit)="salvarConfigImpressora(frmImpressora)">
    <div class="printer-config-layout">
      <div class="printer-config-fields">
        <div class="config-impressora">
      <div class="form-row">
        <div class="form-group">
          <label>Setor</label>
          <input type="text" [(ngModel)]="impressoraSelecionada.setor"
                 [name]="'setor'+indexSelecionado"
                 placeholder="Ex: CAIXA, COZINHA">
        </div>

        <div class="form-group">
          <label>Impressora</label>
          <kendo-dropdownlist name="impressoraNome" #impressoraNome="ngModel"
                              [(ngModel)]="impressoraSelecionada.nome"
                              [data]="impressoras" required
                              (valueChange)="onImpressoraNomeChange()"
                              placeholder="Selecione uma impressora">
          </kendo-dropdownlist>

          <div class="invalid-feedback">
            <p *ngIf="impressoraNome.errors?.required">Obrigatório</p>
          </div>

        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Papel</label>
          <kendo-dropdownlist name="tamanhoPapel"  #tamanhoPapel="ngModel"
                              [(ngModel)]="impressoraSelecionada.tamanhoPapel"
                              [data]="listaTamanhosPapeis" required
                              [textField]="'label'"
                              [valueField]="'valor'"
                              [valuePrimitive]="true"
                              (valueChange)="alterouPapelImpressora()"
                              placeholder="Tamanho do papel">
          </kendo-dropdownlist>
          <div class="invalid-feedback">
            <p *ngIf="tamanhoPapel.errors?.required">Obrigatório</p>
          </div>
        </div>

        <div class="form-group">
          <label>Layout</label>
          <kendo-dropdownlist  name='layout' #layout="ngModel"
                               [(ngModel)]="impressoraSelecionada.layout"
                               [data]="layouts" required
                               [disabled]="isPapelA4Selecionado()"
                               (valueChange)="alterouLayoutImpressora()"
                               placeholder="Escolha o layout">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              {{getLabelLayout(dataItem)}}
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              {{getLabelLayout(dataItem)}}
            </ng-template>
          </kendo-dropdownlist>
          <div class="invalid-feedback">
            <p *ngIf="layout.errors?.required">Obrigatório</p>
          </div>
          <button type="button"
                  class="btn btn-outline-secondary mt-2"
                  *ngIf="impressoraSelecionada?.layout === 'Personalizado' && !isPapelA4Selecionado()"
                  (click)="abrirDialogLayoutPersonalizado()">
            Personalizar layout…
          </button>
        </div>

      </div>
      <!-- Checkbox: Imprimir apenas nesse computador -->
      <div class="checkbox-group mt-2">
        <div class="form-row mb-0">
          <div class="form-group " style="width: 100%">
            <label class="checkbox" style="border: 1px dashed #e74c3c; padding: 8px; border-radius: 6px; background: #fff5f5;">
              <input type="checkbox" [(ngModel)]="impressoraSelecionada.imprimirApenasNesteComputador"
                     [name]="'apenasLocal'+indexSelecionado"
                     (change)="onToggleImprimirApenasNesteComputador()">
              <div style="    display: inline;margin-left: 10px;">
                <strong style="color:#e74c3c">Imprimir apenas em um computador</strong>
                <small> Vincula esta impressora a um computador especifico</small>
              </div>
            </label>
          </div>
        </div>
        <!-- Combo de Servidor + Novo Servidor (quando marcado) -->
        <div  class="form-row"  *ngIf="impressoraSelecionada.imprimirApenasNesteComputador">
          <div class="form-group" style="flex: 1">
            <label>Computador Imprimir</label>
            <kendo-dropdownlist name="servidorImp" #servidorImp="ngModel"
                                [(ngModel)]="impressoraSelecionada.servidorImpressao"
                                [data]="servidoresImpressao"
                                [textField]="'nome'"
                                [valueField]="'id'" required

                                placeholder="Selecione uma maquina imprimir">
            </kendo-dropdownlist>

            <div class="invalid-feedback">
              <p *ngIf="servidorImp.errors?.required">Obrigatório</p>
            </div>

          </div>
          <div class="form-group" style="width: 180px; display:flex; align-items:flex-end;" [hidden]="isMobile" >
            <button type="button" class="btn btn-danger btn-block" (click)="novoServidorRapido()">
              <i class="fe-plus"></i> Imprimir nesse computador
            </button>
          </div>
        </div>
      </div>

      <div class="checkbox-group">
        <label class="checkbox">
          <input type="checkbox" [(ngModel)]="impressoraSelecionada.imprimirAutomatico"
                 [name]="'auto'+indexSelecionado">
          <div>
            Imprimir automaticamente
            <small>Os pedidos serão impressos sem intervenção manual</small>
          </div>
        </label>

        <label class="checkbox" *ngIf="possuiModuloFiscal">
          <input type="checkbox" [(ngModel)]="impressoraSelecionada.imprimirNFCe"
                 [name]="'nfce'+indexSelecionado">
          <div>
            Imprimir NFCe
            <small>Notas fiscais serão impressas nesta impressora</small>
          </div>
        </label>

        <label class="checkbox">
          <input type="checkbox" [(ngModel)]="impressoraSelecionada.naoImprimePedidosMesa"
                 [name]="'mesa'+indexSelecionado">
          <div>
            Não imprimir mesa
            <small>Pedidos de mesa não serão impressos</small>
          </div>
        </label>

        <label class="checkbox">
          <input type="checkbox" [(ngModel)]="impressoraSelecionada.naoImprimePedidosDelivery"
                 [name]="'delivery'+indexSelecionado">
          <div>
            Não imprimir delivery
            <small>Pedidos de delivery não serão impressos</small>
          </div>
        </label>
      </div>

      <div class="comandos-fim">
        <label>Comandos de fim</label>
        <input type="text" [(ngModel)]="impressoraSelecionada.comandosFimImpressao"
               [name]="'comandos'+indexSelecionado"
               placeholder="\x1B\x69">
        <small>Comandos especiais enviados ao final da impressão</small>
      </div>
    </div>

        <div *ngIf="msgErro" class="alert alert-danger">
          {{msgErro}}
        </div>
      </div>

      <div class="printer-preview-column">
        <div class="section-header-preview">
          <h3>Pré-visualização</h3>
        </div>
        <div class="preview-frame-container printer-preview-frame"
             [class.text-preview-container]="isPreviewImpressoraModoTexto()"
             [class.a4-preview-container]="isPapelA4Selecionado()">

          <div *ngIf="isPapelA4Selecionado()" class="preview-a4-action">
            <button type="button"
                    class="btn btn-outline-secondary"
                    [disabled]="!previewImpressoraUrl"
                    (click)="abrirPreviewImpressoraNovaAba()">
              Abrir preview A4
            </button>
          </div>

          <div *ngIf="!isPapelA4Selecionado() && isPreviewImpressoraModoTexto()"
               class="texto-preview-paper"
               [style.width]="getPreviewTextoColunas() + 'ch'">
            <pre *ngFor="let secao of previewImpressoraTextoSecoes"
                 class="texto-preview-secao"
                 [ngClass]="'texto-fonte-' + secao.tamanhoFonte">{{ secao.texto }}</pre>
          </div>

          <iframe *ngIf="!isPapelA4Selecionado() && !isPreviewImpressoraModoTexto() && previewImpressoraUrl"
                  [src]="previewImpressoraUrlSafe"
                  (load)="onIframeImpressoraLoad()"
                  class="preview-iframe"
                  [style.opacity]="previewImpressoraCarregando ? '0.5' : '1'">
          </iframe>

        </div>
      </div>
    </div>
    <kendo-dialog-actions>
      <button type="button" class="btn-secondary" (click)="fecharConfigImpressora()">Cancelar</button>
      <button type="submit" class="btn-success"  >Salvar</button>
    </kendo-dialog-actions>
  </form>

</kendo-dialog>

<kendo-dialog *ngIf="dialogLayoutAberto"
              (close)="fecharDialogLayoutPersonalizado(false)"
              [minWidth]="500"
              [width]="950"
              class="custom-layout-dialog">

  <kendo-dialog-titlebar>
    <div class="dialog-title">Layout do Comprovante</div>
  </kendo-dialog-titlebar>

  <div class="dialog-content-wrapper">
    <div class="config-column">
      <div class="section-header">
        <h3>Campos Visíveis</h3>
        <p>As alterações são aplicadas instantaneamente ao preview.</p>
      </div>

      <div class="options-container custom-scroll">
        <div *ngFor="let opt of opcoesLayoutDef; trackBy: trackByOpcaoLayout"
             class="option-row"
             (click)="opcoesLayoutTemp[opt.key] = !opcoesLayoutTemp[opt.key]; alterouOpcoesLayoutTemp()">

          <div class="option-main">
            <input type="checkbox"
                   class="k-checkbox k-checkbox-md k-rounded-md"
                   [id]="'opt_' + opt.key"
                   [(ngModel)]="opcoesLayoutTemp[opt.key]"
                   [ngModelOptions]="{standalone: true}"
                   (click)="$event.stopPropagation()"
                   (change)="alterouOpcoesLayoutTemp()">

            <label class="option-label" [attr.for]="'opt_' + opt.key" (click)="$event.stopPropagation()">
              <span class="label-title">{{ opt.label }}</span>
              <span class="label-help">{{ opt.help }}</span>
            </label>
          </div>

          <div class="option-style"
               *ngIf="!isPreviewModoTexto() || opt.permiteTamanhoTexto !== false"
               (click)="$event.stopPropagation()">
            <label class="style-control">
              <span>{{ getLabelFonteLayout() }}</span>
              <select [(ngModel)]="opcoesLayoutTemp.estilos[opt.key].tamanhoFonte"
                      [ngModelOptions]="{standalone: true}"
                      (change)="alterouOpcoesLayoutTemp()">
                <option *ngFor="let tamanho of getTamanhosFonteLayout()" [ngValue]="tamanho.valor">
                  {{ tamanho.label }}
                </option>
              </select>
            </label>
          </div>
        </div>
      </div>

      <div class="actions-inline">
        <button kendoButton fillMode="flat" size="small" (click)="marcarTodosOpcoesLayoutTemp(true)">
          Marcar tudo
        </button>
        <button kendoButton fillMode="flat" size="small" (click)="marcarTodosOpcoesLayoutTemp(false)">
          Desmarcar tudo
        </button>
      </div>
    </div>

    <div class="preview-column">
      <div class="section-header-preview">
        <h3>
          Pré-visualização</h3>
      </div>
      <div class="preview-frame-container" [class.text-preview-container]="isPreviewModoTexto()">

        <div *ngIf="isPreviewModoTexto()" class="texto-preview-paper" [style.width]="getPreviewTextoColunas() + 'ch'">
          <pre *ngFor="let secao of previewTextoSecoes"
               class="texto-preview-secao"
               [ngClass]="'texto-fonte-' + secao.tamanhoFonte">{{ secao.texto }}</pre>
        </div>

        <iframe *ngIf="!isPreviewModoTexto() && previewUrl"
                [src]="previewUrlSafe"
                (load)="onIframeLoad()"
                class="preview-iframe"
                [style.opacity]="previewCarregando ? '0.5' : '1'">
        </iframe>

      </div>
    </div>
  </div>

  <kendo-dialog-actions layout="stretched">
    <button kendoButton (click)="fecharDialogLayoutPersonalizado(false)">Cancelar</button>
    <button kendoButton themeColor="primary" (click)="fecharDialogLayoutPersonalizado(true)">
      Salvar Alterações
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

